<div [ngClass]="{loading: !evaluationData}">    
    <true-breadcrumbs [subset]="this.config.subset" [assessmentName]="assessmentName + ' (' + assessmentObject + ')'"></true-breadcrumbs>
    <div class="venn-container">
        <div class="venn floated" [ngClass]="{pillarModels: config.pillar_models}">            
            <true-evaluation-diagram *ngIf="config.pillar_models && evaluationData" [values]="evaluationData" [options]="{}"></true-evaluation-diagram>
        </div>        

        <!--<div class="button-container" *ngIf="config.pillar_models && evaluationData">
            <div class="button pillarModels" id="bottomUpButton" (click)="bottomUp()">
                <em>Modify input</em>
                <span>(bottom-up analysis)</span>
            </div>
            <div class="button pillarModels" id="topDownButton" (click)="topDown()">
                <em>Modify goal</em>
                <span>(top-down analysis)</span>
            </div>
        </div>-->
    </div>
    <true-node-chains [pillars]="pillars"></true-node-chains>
</div>

<div id="topDownPicker" *ngIf="topDownModal" (focusout)="closeTopDownModal()">
    <div #topDownPicker>
        <ul>
            <li *ngFor="let tier of topDownData">
                <ul>
                    <li *ngFor="let item of tier" [ngClass]="{'highlightSelectedOnly': topDownChanged, 'selected': item.change != 0}">
                        <div [ngClass]="valueClass(item.value)"></div> <span>{{item.name}}</span> <true-binary-input [(value)]="item.change" (change)="topDownChange(item)" [can-improve]="item.value<2" [can-degrade]="item.value>0" ></true-binary-input>
                    </li>
                </ul>
            </li>
        </ul>
        <div class="modalLink" [ngClass]="{'active': topDownChanged}" (click)="generateTopDown()">generate results</div>
        <div class="modalLink back" (click)="closeTopDownModal()">return back</div>
    </div>
</div>
